export default __webpack_public_path__ + "static/media/sneakerNFTBgMb.7401e45b.png";